<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col  lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Inventory Management</h6>
        </b-col>
        <b-col  lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
                <b-tab title="Load SIMs">
                  <LoadSIMs></LoadSIMs>
                </b-tab>
                <b-tab title="Load MSISDNs">
                  <LoadMSISDNs></LoadMSISDNs>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">

    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import LoadSIMs from './LoadSims';
  import LoadMSISDNs from './LoadMSISDNs'

  export default {
    name: "Inventory-Management",
    components: {
      RouteBreadCrumb,
      LoadSIMs,
      LoadMSISDNs
    },
    mounted() {
      document.title = 'Administrator'
    }
  }
</script>

<style scoped>

</style>
